import { render, staticRenderFns } from "./WarehouseTransaction.vue?vue&type=template&id=34f74a1e&"
import script from "./WarehouseTransaction.vue?vue&type=script&lang=js&"
export * from "./WarehouseTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports